import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	statusUpdateTitle: {
		id: 'search-page.mercury.focus-area-update.title',
		defaultMessage: 'Update for {focusAreaName}',
		description: 'Focus area status update title',
	},
});
